var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2847",
    clipPath: "url(#clip0_8253_2413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4212 16.2943H6.74535C6.25557 16.2989 5.77925 16.1444 5.3975 15.8572C5.01575 15.57 4.75216 15.1679 4.65161 14.7193L3.186 8.57746C3.12293 8.31968 3.1229 8.0519 3.1859 7.79411C3.24889 7.53632 3.3733 7.29518 3.54983 7.08868C3.72636 6.88218 3.95045 6.71567 4.20537 6.60156C4.46029 6.48745 4.73946 6.4287 5.02204 6.4297L19.3492 6.4297L18.4908 14.7193C18.2627 15.2617 18.1293 15.5619 17.7528 15.8484C17.3764 16.1349 16.9065 16.2922 16.4212 16.2943Z",
    stroke: "#F20E45",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7 22.0005C8.10457 22.0005 9 21.1051 9 20.0005C9 18.8959 8.10457 18.0005 7 18.0005C5.89543 18.0005 5 18.8959 5 20.0005C5 21.1051 5.89543 22.0005 7 22.0005Z",
    stroke: "#F20E45",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16 22.0005C17.1046 22.0005 18 21.1051 18 20.0005C18 18.8959 17.1046 18.0005 16 18.0005C14.8954 18.0005 14 18.8959 14 20.0005C14 21.1051 14.8954 22.0005 16 22.0005Z",
    stroke: "#F20E45",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.934 10.9539L19.652 4.49212C19.7091 3.99578 19.97 3.62574 20.3428 3.2648C20.7156 2.90385 21.2054 2.66962 21.7327 2.60012L23.1391 2.33824",
    stroke: "#F20E45",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8253_2413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.e1aa812a31a6e138a5f9bf06d6957952.svg";
export { ForwardRef as ReactComponent };